import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import React from "react";
import {
  ComponentMultiStyleConfig,
  HStack,
  Link,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { DeleteIconButton } from "../../../icon-button";
import { CMDatetimeText } from "../../../text";

export type FileUploadFormRowProps = {
  fileName: string;
  fileUrl: string;
  date: Date;
  deleteButtonTip?: string;

  onDelete: () => void;
} & ComponentStyleProps;

export const FileUploadFormRow = ({
  fileName,
  fileUrl,
  date,
  deleteButtonTip,

  onDelete,

  sx,
  ...rest
}: FileUploadFormRowProps) => {
  const styles = useMultiStyleConfig("FileUploadFormRowStyles");

  return (
    <HStack sx={{ ...styles.container, ...sx }} {...rest}>
      <Link href={fileUrl} isExternal sx={styles.file}>
        {fileName}
      </Link>
      <CMDatetimeText value={date} sx={styles.date} />
      <DeleteIconButton
        size="sm"
        tipMessage={deleteButtonTip}
        ariaLabel="Delete card"
        onClick={onDelete}
        sx={styles.deleteButton}
      />
    </HStack>
  );
};

export const FileUploadFormRowStyles: ComponentMultiStyleConfig = {
  parts: ["container", "file", "date", "icon"],
  baseStyle: {
    container: {},
    file: {
      fontSize: "sm",
      color: "blue.600",
    },
    date: {
      fontSize: "xs",
      color: "gray.600",
    },
    icon: {
      borderRadius: "20px",

      fontSize: "sm",
      color: "gray.200",

      _hover: {
        bgColor: "gray.100",
        color: "gray.600",
      },
    },
  },
};
